function StockLedgerIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 1.33325L14 4.66658V13.9953C14.0006 14.0828 13.984 14.1696 13.951 14.2507C13.9181 14.3319 13.8695 14.4057 13.808 14.468C13.7466 14.5304 13.6734 14.58 13.5928 14.6141C13.5121 14.6481 13.4255 14.666 13.338 14.6666H2.662C2.48692 14.6654 2.31934 14.5953 2.19548 14.4716C2.07161 14.3478 2.0014 14.1803 2 14.0053V1.99459C2 1.62925 2.298 1.33325 2.666 1.33325H10.6667ZM10 2.66659H3.33333V13.3333H12.6667V5.33325H10V2.66659ZM8.66667 5.99992V8.66658H10.6667V9.99992H7.33333V5.99992H8.66667Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default StockLedgerIcon
